// Per-site brand/config layer. One build serves ONE site: REACT_APP_SITE
// selects the brand at build time ('chadha' default, 'nihirote' for
// nihirote.surf). Everything brand-specific a component needs — name
// fragments, nav order, homepage variant flags — lives here so adding or
// tweaking a site is a one-file change plus a .env.
const SITES = {
  chadha: {
    id: 'chadha',
    domain: 'chadha.surf',
    // Brand renders as `${brandA}<span>${brandB}</span>` in the nav/login.
    brandA: 'chadha',
    brandB: 'surf',
    siteName: 'chadha.surf',
    // Public nav order (auth-only links keep their fixed order after these).
    // Forecasting pages lead; films/trips follow.
    navOrder: ['home', 'forecast', 'swellmap', 'globe', 'movies', 'trips'],
    // Rote pages/spots are nihirote-only (hasRote gates the /rote route, the
    // nav link, and Rote-region spots in the shared forecast catalog).
    hasRote: false,
    // Bo'a is the one Rote spot surfaced on this site's forecast page.
    spotAllow: ['boa-rote-id'],
    home: {
      // Homepage (Browse.js) layout flags — chadha: hero first, movies, trips.
      heroFirst: true,
      tripsBeforeMovies: false,
      tagline: null,
    },
    dropId: 'chadhaSurfDrop',
    lookName: 'Chadha Look',
    lookGroup: 'Chadha',
    // This site has its own ECS backend service (upload API, voice agent,
    // knowledge chat). high.surf is frontend-only — its REACT_APP_UPLOAD_API
    // host falls through the shared ALB to chadha, where high tokens fail
    // verification, so backend-dependent UI (ChatAgent) gates on this.
    hasBackend: true,
  },
  nihirote: {
    id: 'nihirote',
    domain: 'nihirote.surf',
    brandA: 'nihirote',
    brandB: 'surf',
    siteName: 'nihirote.surf',
    // Resort-inspired light "sand" theme (see the `nihi` blocks in index.css):
    // serif wordmark, tracked-uppercase nav, sand/brass palette on public pages.
    theme: 'nihi',
    // Rote IS the homepage, so no separate 'rote' nav entry.
    navOrder: ['home', 'forecast', 'swellmap', 'globe', 'movies', 'trips'],
    hasRote: true,
    home: {
      page: 'rote', // '/' renders the Rote strike-mission board
      heroFirst: true,
      tripsBeforeMovies: true,
      tagline: 'Rote-first surf forecasting and trip film archives.',
    },
    dropId: 'nihiroteSurfDrop',
    lookName: 'Nihirote Look',
    lookGroup: 'Nihirote',
    hasBackend: true,
  },
  high: {
    id: 'high',
    domain: 'high.surf',
    brandA: 'high',
    brandB: 'surf',
    siteName: 'high.surf',
    // Brand mark: the wave diamond traced from the Hawaii ocean-safety HIGH
    // SURF sign, recolored to the water gradient (mark.svg), plus a full
    // "HIGH SURF" lockup (logo.svg) that replaces the text brand in the nav.
    // Assets in public/brand-high/; favicon swapped in by build:high.
    logo: '/brand-high/logo.svg',
    logoWordmark: true,
    // The swell map IS the homepage, so no separate 'swellmap' nav entry.
    // Forecasting pages lead (home = swell map, globe, forecast), then films.
    navOrder: ['home', 'globe', 'forecast', 'movies', 'trips'],
    hasRote: false,
    // Rote-region spots are hidden on non-Rote sites except these ids.
    spotAllow: ['boa-rote-id'],
    home: {
      page: 'swellmap', // '/' renders the global swell map
      heroFirst: true,
      tripsBeforeMovies: false,
      tagline: null,
    },
    dropId: 'highSurfDrop',
    lookName: 'High Look',
    lookGroup: 'High',
    hasBackend: false, // frontend-only site — no ECS service of its own
  },
};

const SITE = SITES[process.env.REACT_APP_SITE] || SITES.chadha;

export default SITE;
